import React from 'react'
import readablePayMethod from 'helpers/readablePayMethod'

const OrderHeader = ({ order }) => {
  const handleDownloadInvoice = () => {
    if (order.invoice_url) {
      window.open(order.invoice_url, '_blank')
    }
  }

  return (
    <div className="bg-slate-50 px-4 sm:px-6 lg:px-7 py-4 border-b border-slate-200 relative overflow-hidden">
      <div className="flex flex-col md:flex-row gap-6 justify-between items-start relative">
        <div className="flex flex-col md:flex-row justify-between w-full md:mr-6">
          <div className="flex flex-col gap-2">
            <span className="text-[13px] text-slate-500 font-medium uppercase tracking-wide">
              განთავსების თარიღი
            </span>
            <span className="font-bold text-base lg:text-[17px] text-slate-800">
              {order.date}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-[13px] text-slate-500 font-medium uppercase tracking-wide">
              სრული თანხა
            </span>
            <span className="font-bold text-lg lg:text-[19px] text-[#f00000]">
              {order.is_installment
                ? `${order.installment_price}₾/თვეში`
                : `${order.meta.price}₾`}
            </span>
          </div>
          <div className="flex flex-col gap-2 sm:col-span-2 lg:col-span-1">
            <span className="text-[13px] text-slate-500 font-medium uppercase tracking-wide">
              გადახდის მეთოდი
            </span>
            <span className="font-semibold text-base lg:text-[17px] text-slate-800">
              {readablePayMethod(order.meta.pay_method)}
            </span>
          </div>
        </div>

        {order.invoice_url && (
          <button
            className="bg-citrus-red hover:bg-red-600 active:bg-[#b00000] text-white text-sm lg:text-[15px] px-4 sm:px-6 py-3 rounded-xl font-medium transition-all duration-200 flex items-center gap-3 w-full sm:w-auto justify-center shadow-lg hover:shadow-xl transform"
            onClick={handleDownloadInvoice}
          >
            <i className="fas fa-download text-[13px]"></i>
            <span>ინვოისის გადმოწერა</span>
          </button>
        )}
      </div>
    </div>
  )
}

export default OrderHeader
